const Module = {
  DASHBOARD: 'dashboard',
  LEAVES: 'leaves',
  ATS_DASHBOARD: 'ats_dashboard',
  EXPENSES: 'expenses',
  TIME_ENTRIES: 'timeEntries',
  APPROVAL_LEAVES: 'approvalLeaves',
  APPROVAL_EXPENSES: 'approvalExpenses',
  APPROVAL_TIME_ENTRIES: 'approvalTimeEntries',
  POLICIES: 'policies',
  PRE_DEFINED_REPORTS: 'preDefinedReports',
  CUSTOM_REPORTS: 'customReports',
  USER_MANAGEMENT: 'userManagement',
  TIMESHEET_CONFIGURATION: 'timesheetConfiguration',
  EMAIL_TEMPLATES: 'emailTemplates',
  ORGANIZATION_SETUP: 'organizationSetup',
  ALL_APPROVAL_TIME_ENTRIES: 'allApprovalTimeEntries',
  ALL_APPROVAL_EXPENSES: 'allApprovalExpenses',
  ALL_APPROVAL_LEAVES: 'allApprovalLeaves',
  ATS_RECRUITER: 'atsRecruiter',
  ATS_RECRUITER_ADMIN: 'atsRecruiterAdmin',
  ATS_INTERVIEWER: 'ATSInterviewer',
  VR_ASSISTANT: 'vrAssistant',
  ORGANIZATIONS: 'organizations',
} as const;

export type ModuleType = typeof Module[keyof typeof Module];

export {
  Module,
};
